var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoofSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.4697266,2.4453125c-0.8730469-0.5820312-2.0654297-0.5820312-2.9404297,0L1.4453125,11.1679688l1.109375,1.6640625 L15.6376953,4.109375c0.2167969-0.1425781,0.5087891-0.1425781,0.7236328,0l13.0839844,8.7226562l1.109375-1.6640625 L17.4697266,2.4453125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7646484,16.2927246l-1.3173828-2.6345215C21.9355469,12.6357422,20.9072266,12,19.7636719,12h-7.5273438 c-1.1435547,0-2.171875,0.6357422-2.6835938,1.6582031l-1.3173828,2.6345215C6.8522949,17.126709,6,18.6008301,6,20.2363281 l0.0048828,8.046875C6.0048828,29.2460938,6.8828125,30,8.0029297,30h1.9980469C11.1220703,30,12,29.2460938,12,28.2832031V26h8 v2.2832031C20,29.2460938,20.8789062,30,22,30h2c1.1210938,0,2-0.7539062,2-1.7167969v-8.046875 C26,18.6008301,25.1477051,17.126709,23.7646484,16.2927246z M11.3417969,14.5527344 C11.5117188,14.2119141,11.8544922,14,12.2363281,14h7.5273438c0.3818359,0,0.7246094,0.2119141,0.8945312,0.5527344L21.3818359,16 H10.6181641L11.3417969,14.5527344z M10,28H8.0048828v-2H10V28z M24,28h-2v-2h2V28z M24,24H8.0048828L8,22.0146484h4v-2H8.0285645 C8.0996094,19.1809082,8.5407715,18.4345703,9.2558594,18h13.4882812c0.7150879,0.4345703,1.1563721,1.1809082,1.2272949,2.0146484 H20v2h4V24z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoofSmall);
export default __webpack_public_path__ + "static/media/roof--small.c604058d8754f86e05c3927695cc8ee1.svg";
export { ForwardRef as ReactComponent };